import { Dispatch, UnknownAction } from '@reduxjs/toolkit';
import { updateProjectSetting } from 'features/project';
import {
  setSystemPtacPreferences,
  SystemRecommendationSelectionsEntry
} from 'features/structure/structure-slice';
import { HAS_EXISTING_EQUIPMENT_NO } from 'utils/existing-equipment-page-visibility';
import { withPtacReplacingAnswer } from 'utils/ptac-preferences';
import { persistPtacPreferences } from 'utils/ptac-preferences-persist';
import { PtacExistingUnitsRecord } from '@alpinehomeair/common';

export const REMOVE_EXISTING_PTAC_CONFIRM_TITLE =
  'Remove existing PTAC details?';

export const REMOVE_EXISTING_PTAC_CONFIRM_MESSAGE =
  'This will clear the answers about the PTAC units being replaced.';

export const REMOVE_EXISTING_PTAC_CONFIRM_BUTTON = 'Remove Details';

export function hasExistingPtacAnswers(
  existing: PtacExistingUnitsRecord | undefined
): boolean {
  return (
    !!existing &&
    (existing.sleeveStandard !== null ||
      existing.sleeveCondition !== null ||
      existing.grille !== null ||
      existing.control !== null ||
      !!existing.modelNumber)
  );
}

export function applyNoExistingPtacAnswer(
  dispatch: Dispatch<UnknownAction>,
  anchor: {
    systemUniqueId: string;
    entry: SystemRecommendationSelectionsEntry | null | undefined;
  } | null
): void {
  if (anchor) {
    const ptac = withPtacReplacingAnswer(anchor.entry?.ptac ?? {}, false);
    dispatch(
      setSystemPtacPreferences({ systemUniqueId: anchor.systemUniqueId, ptac })
    );
    persistPtacPreferences(anchor.systemUniqueId, anchor.entry, ptac);
  }
  dispatch(
    updateProjectSetting({
      attributeCode: 'project_type',
      value: HAS_EXISTING_EQUIPMENT_NO
    })
  );
}
